import Head from './TopHead';
import Curric from './Curric';

function Sql() {
    return (
        <main>
            <Head />

            <h1>SQL Queries</h1>

            <section className="section">
                <h2>Microsoft SQL or MySQL Fundamental Skills: 3 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="SQL INTRODUCTION - Retrieve Data (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn SQL Fundamentals: SELECT, FILTER & JOIN queries.
                        </div>
                        <ul>
                            <li>SELECT</li>
                            <li>WHERE</li>
                            <li>NULL</li>
                            <li>AS</li>
                            <li>ORDER BY</li>
                            <li>AND & OR</li>
                            <li>DISTINCT</li>
                            <li>IN</li>
                            <li>LIKE</li>
                            <li>JOINS</li>
                            <li>Undestand JOIN Types</li>
                            <li>USING & ON</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic computer skills, including saving and
                            locating files.</div>
                    </Curric>

                    <Curric title="SQL INTERMEDIATE - Analyze Data (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> SQL for Analyst - Join Tables, Merge Tables, Calculated Columns, Summary Reports.
                        </div>
                        <ul>
                            <li>AGGREGATE functions</li>
                            <li>GROUP BY</li>
                            <li>Calculated Columns</li>
                            <li>HAVING</li>
                            <li>UNION, UNION ALL</li>
                            <li>JOINS with GROUP BY</li>
                            <li>Table aliases</li>
                            <li>SELF JOIN</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b>
                            Basic SQL skills, basic math skills, some understanding of SQL joins.
                        </div>
                    </Curric>

                    <Curric title="SQL ADVANCED - SUBQUERIES (3-4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> SQL - Build More Complicated Queries.
                        </div>
                        <ul>
                            <li>Functions & Date functions</li>
                            <li>Functions & WHERE clause</li>
                            <li>IF statements</li>
                            <li>SUBQUERIES</li>
                            <li>WITH</li>
                            <li>Variables</li>
                            <li>Create VIEWS</li>
                            <li>OVER</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Know of SQL joins and Group BY.</div>
                    </Curric>
                </div>
            </section>

            <hr />

            <section className="section">
                <h2>SQL For Developers: 1 Level</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="SQL INTRODUCTION (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn SQL Fundamentals: INSERT, SELECT, UPDATE, DELETE commands.
                        </div>
                        <ul>
                            <li>SELECT</li>
                            <li>WHERE</li>
                            <li>ORDER BY</li>
                            <li>AND & OR</li>
                            <li>IN</li>
                            <li>LIKE</li>
                            <li>INSERT</li>
                            <li>UPDATE</li>
                            <li>DELETE</li>
                            <li>BASIC JOIN</li>
                            <li>TRANSACTION</li>
                            <li>COMMIT</li>
                            <li>ROLLBACK</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic computer skills, basic developer skills.</div>
                    </Curric>

                </div>
            </section>


        </main>

    );
}

export default Sql;